<script>
  // @ts-check
  import { getContext, afterUpdate } from "svelte";
  import {
    HERO_COMPONENT_MAP,
    getHeroVariantProps,
    HERO_VARIANTS_WITH_THEME,
    getBreakpointAdjustedFields
  } from "$lib/utilities/contentTypes/hero";
  import Hero from "$lib/components/Hero.svelte";
  import { heroThemeStore, heroFormFactorStore } from "$lib/stores";
  // eslint-disable-next-line @ObamaFoundation/of-svelte/no-stores
  import { page } from "$app/stores";
  export let data;

  let formFactor = data.fields?.formFactor;

  const component = HERO_COMPONENT_MAP[formFactor];
  const pageDataContext = getContext("pageData");

  let screenWidth = 0;

  // The image and contentful video displayed on the hero can depend on the current breakpoint.
  $: breakpointAdjustedFields = getBreakpointAdjustedFields(data.fields, screenWidth);

  $: heroProps = getHeroVariantProps(
    breakpointAdjustedFields,
    pageDataContext,
    $page?.url?.pathname
  );

  let hasThemedBackground = HERO_VARIANTS_WITH_THEME.includes(formFactor);

  afterUpdate(() => {
    if (hasThemedBackground) {
      // Used to update the the Global Navigation background color based on current Home Hero background color
      heroThemeStore.set(heroProps?.theme ?? "white");
      heroFormFactorStore.set(heroProps.formFactor ?? "");
    } else {
      heroThemeStore.set("white");
    }
  });
</script>

<svelte:window bind:innerWidth={screenWidth} />

<Hero data={heroProps} {component} />
